import React from 'react';
import cx from 'classnames';
import { Container } from 'reactstrap';
import Slider from 'react-slick';

import partner1 from './img/partners/image009.jpg';
import partner2 from './img/partners/image010.jpg';

class Partners extends React.Component {
  render() {
    const {
      styles: s,
    } = this.props;

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      <div>
        <section className={cx(s.brandsArea, s.brBg, s.keyBg)}>
          <Container>
            <div className={cx(s.sectionTitleThree, s.titleGr, s.mb60)}>
              <h2><span>Our</span> Partners</h2>
            </div>
            <div className={s.clientdiv}>
              <div>
                <img src={partner1} alt="img_one" />
              </div>
              <div>
                <img src={partner2} alt="img_two" />
              </div>
            </div>
          </Container>
        </section>
      </div>
    );
  }
}

export default Partners;



// WEBPACK FOOTER //
// ./src/routes/home/Partners.js